import NotificationWebDisplayResponse from "../models/notification_web_display_response";

export default class NotificationWebDisplayState {
    isLoading: boolean = true;
    response?: NotificationWebDisplayResponse;
    errorMessage?: string;
}